<div class="row g-0 h-100 relFix">

  <div id="myMap"></div>

  @if (isLoadingProjects) {
  <div class="map-loading bg-white rounded shadow px-3 py-2 d-flex align-items-center gap-2">
    <div class="spinner-border spinner-border-sm text-secondary" role="status"></div>
    <span>Loading projects...</span>
  </div>
  }

  <div class="input-group mb-3 sbox shadow">
    <span class="input-group-text search-icon" id="basic-addon1">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
      </svg>
    </span>

    <input type="text"
           [(ngModel)]="searchText"
           placeholder="Search Projects"
           class="form-control" />
  </div>

  <div class="sResult">
    <div class="list-group shadow" id="results-panel">
      <a class="list-group-item list-group-item-action d-flex gap-3 py-3" (mouseenter)="onHover(searchProject)" (click)="zoomToProject(searchProject)" *ngFor="let searchProject of projects | filter:searchText:'displayName'">
        <div class="d-flex gap-2 w-100 justify-content-between">
          <div>
            <h6 class="mb-0">{{ searchProject.name }}</h6>
            <p class="mb-0 opacity-75">{{ searchProject.location.address}}, {{ searchProject.location.city}}, {{ searchProject.location.state}} {{ searchProject.location.zip}}</p>
          </div>
        </div>
      </a>
    </div>
  </div>

  <div class="img-fluid" style="position: absolute; top: calc(100vh - 220px); left: calc(100vw - 160px);">
    <img src="assets/atlas_logo.png" style="width: 120px;" />
  </div>

  <!-- Main Window Drawer -->
  <div class="offcanvas offcanvas-start fullWidth" [ngClass]="{ 'show': mainWindowVisible===true}" tabindex="-2" id="mainWindowDrawer" data-bs-scroll="true" style="margin-top: 65px;">
    <div class="d-flex flex-column h-100 drawer2">
      <div class="d-flex w-100 justify-content-end" sstyle="min-height: 40px;">
        <button class="btn btn-sm btn-outline-secondary" (click)="closeContentWindow()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <iframe [src]="iframeUrl" style="box-sizing: border-box; border: 1px solid #444; position: absolute; top: 40px; left: 480px; width: calc(100% - 480px); height: calc(100% - 40px);"></iframe>
    </div>
  </div>

  <!-- Details Drawer -->

  <div class="offcanvas offcanvas-start" [ngClass]="{ 'show': collapsed===false}" tabindex="-1" id="locationDrawer" data-bs-scroll="true" style="margin-top: 65px;">
    <div class="d-flex flex-column h-100 drawer">

      <!-- Header Image -->
      <!--<img src="{{ project?.images[0] }}" class="img-fluid" style="height: 180px; width: 100%; object-fit: cover;" alt="">-->
      <img src="https://saworkmediaprodcus01.blob.core.windows.net/project-photos/IMG_8080-Edit-Edit-1140x760.jpg" class="img-fluid" style="height: 180px; width: 100%; object-fit: cover;" alt="">

      <!-- Content -->
      <div class="p-3 overflow-auto">

        <div class="d-flex justify-content-between mb-3" style="height: 100px;">

          <div>
            <h5 class="mb-1">
              {{ project?.displayName }}
            </h5>

            <div class="text-muted">
              {{ project?.location.address}}, {{ project?.location.city}}, {{ project?.location.state}} {{ project?.location.zip}}
            </div>
          </div>

          <button class="btn btn-sm btn-outline-secondary" (click)="toggleDrawer()">
            <i class="bi bi-x-lg"></i>
          </button>

        </div>

        <ul class="nav nav-tabs">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" id="overview-tab" data-bs-toggle="tab" data-bs-target="#overview" role="tab" aria-controls="overview" aria-selected="true">Overview</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="employees-tab" data-bs-toggle="tab" data-bs-target="#employees" role="tab" aria-controls="employees" aria-selected="false">Employees</a>
          </li>
          <!--<li class="nav-item" role="presentation">
        <a class="nav-link" id="images-tab" data-bs-toggle="tab" data-bs-target="#images" role="tab" aria-controls="images" aria-selected="false">Images</a>
      </li>-->
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="images-more" data-bs-toggle="tab" data-bs-target="#more" role="tab" aria-controls="more" aria-selected="false">More Options</a>
          </li>
        </ul>

        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="overview" role="tabpanel" aria-labelledby="overview-tab" style="height: calc(100vh - 450px); overflow-y: auto; overflow-x: hidden">

            <p class="mb-3">
              {{ project?.description | stripHtml }}
            </p>

            <div class="row">
              <div class="col-6 mb-3">
                <strong>Delivery Method</strong>
                <p class="mb-0">{{ project?.deliveryMethod ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Project Size</strong>
                <p class="mb-0">{{ project?.projectSize ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Contract Type</strong>
                <p class="mb-0">{{ project?.contractType ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Contract Value</strong>
                <p class="mb-0">{{ project?.contractValue | currency:'USD':'symbol':'1.2-2' }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Constuction Cost</strong>
                <p class="mb-0">{{ project?.constructionCost | currency:'USD':'symbol':'1.2-2' }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Owner</strong>
                <p class="mb-0">{{ project?.owner ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Client</strong>
                <p class="mb-0">{{ project?.client ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Architect</strong>
                <p class="mb-0">{{ project?.architect ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Start Date</strong>
                <p class="mb-0">{{ project?.startDate ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>End Date</strong>
                <p class="mb-0">{{ project?.completionDate ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Company</strong>
                <p class="mb-0">{{ project?.company.name ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Region</strong>
                <p class="mb-0">{{ project?.region ?? "--" }}</p>
              </div>

              <div class="col-6 mb-3">
                <strong>Market</strong>
                <p class="mb-0">{{ project?.market ?? "--" }}</p>
              </div>

            </div>
          </div>

          <div class="tab-pane fade" id="employees" role="tabpanel" aria-labelledby="employees-tab" style="height: calc(100vh - 450px); overflow: auto;">

            <div class="d-flex gap-2 mb-4" *ngFor="let employee of project?.personnel">
              <div class="" style="width: 100px; height: 100px;">
                <div style="background-image: url(&quot;{{employee.imageUrl}}&quot;); background-size: cover; background-repeat: no-repeat; background-position: center center; width: 100%; height: 100%;"></div>
              </div>

              <p class="p-1">
                <strong>{{ employee.name }}</strong><br />
                {{ employee.title }}<br />
                {{ employee.email }}<br />
                {{ employee.work | prefix:'W: ':' | ' }} {{ employee.mobile | prefix:'M: ':'' }}
              </p>
            </div>

          </div>

          <!--<div class="tab-pane fade" id="images" role="tabpanel" aria-labelledby="images-tab" style="height: calc(100vh - 450px); overflow: auto;">

        <img src="{{image}}" class="img-fluid mb-3" style="width: 500px;" *ngFor="let image of project?.images" />

      </div>-->

        <div class="tab-pane fade" id="more" role="tabpanel" aria-labelledby="more-tab" style="height: calc(100vh - 450px); overflow-y: auto; overflow-x: hidden;">

            @if (canViewAlberIQ) {
            <a class="btn btn-outline-secondary w-100 mb-2" (click)="showAlbericiAIWindow()" [ngClass]="{ 'active': activeWindow === 'alberiq' }">
              AlberIQ
            </a>
            }

          <a class="btn btn-outline-secondary w-100 mb-2" (click)="showAnalyticsWindow()" [ngClass]="{ 'active': activeWindow === 'powerbi' }">
            Project Analytics
          </a>

            @if (CanViewProjectSiteConditions) {
            <a class="btn btn-outline-secondary w-100 mb-2" (click)="showTrueLookWindow()" [ngClass]="{ 'active': activeWindow === 'truelook' }">
              Project Site Conditions
            </a>
            }

            @if (canViewPPRList) {
            <a class="btn btn-outline-secondary w-100 mb-2" (click)="showPPRWindow()" [ngClass]="{ 'active': activeWindow === 'ppr' }">
              Project Performance
            </a>
            }

          <!--
          @if (project?.cameraUrl) {
          <a class="btn btn-outline-secondary w-100 mb-2" (click)="showTrueLookWindow()" [ngClass]="{ 'active': activeWindow === 'truelook' }">
            Project Site Conditions
          </a>
          }

          @if (project?.pprUrl) {
          <a class="btn btn-outline-secondary w-100 mb-2" (click)="showPPRWindow()" [ngClass]="{ 'active': activeWindow === 'ppr' }">
            Project Performance
          </a>
          }
          -->

        </div>

        </div>

      </div>

    </div>
  </div>

</div>
